module.exports = __webpack_public_path__ + "static/media/p22.16778cdf.jpeg";